import '../SCSS/App.scss';

  const Info = () => {
          return (
            
            <div className="web-info row text-white">
                <div className="col-6 col-sm-4  text-center bg-dark p-2">
                   <p className="m-0">30-Day Returns</p>
                </div>
                <div className="col-6 col-sm-4 text-center bg-dark p-2">
                   <p className="m-0">2 Year Warranty</p>
                </div>
                <div className="col-4 d-none d-sm-block col-sm-4 text-center bg-dark p-2">
                    <p className="m-0 ">Free Shipping over ₹250</p>
                </div>
          </div>
         )
       };


export default Info;
